import {
  AlphaFormat,
  RedFormat,
  RedIntegerFormat,
  RGFormat,
  RGIntegerFormat,
  RGBAFormat,
  RGBAIntegerFormat,
  LuminanceFormat,
  LuminanceAlphaFormat,
  DepthFormat,
  DepthStencilFormat
} from "three";
export const TEXTURE_FORMATS = [
  { AlphaFormat },
  { RedFormat },
  { RedIntegerFormat },
  { RGFormat },
  { RGIntegerFormat },
  { RGBAFormat },
  { RGBAIntegerFormat },
  { LuminanceFormat },
  { LuminanceAlphaFormat },
  { DepthFormat },
  { DepthStencilFormat }
];
